import { useQuery } from "@tanstack/react-query"
import { getAllFeedCommentAdmin, getFeedCommentAdminByFeedCommentId } from "../../../../service/feedComment";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { DefaultOptionType } from "antd/es/select";
import FeedCommentManageModal from "../ui/modal";

const useGetFeedCommentAdminByFeedCommentId = <T,>(feedCommentId: number, enabled: boolean = false, responseQuery?: string) => {
    const query = useQuery({
        queryKey: ['getFeedCommentAdminByFeedCommentId', feedCommentId, responseQuery],
        queryFn: () => getFeedCommentAdminByFeedCommentId<T>(feedCommentId, responseQuery),
        select: res => res.data.data.getFeedCommentAdminByFeedCommentId,
        enabled: !!feedCommentId && !!enabled
    })
    return query;
}

const useGetAllFeedCommentAdmin = <T,>(responseQuery?: string) => {
    const query = useQuery({
        queryKey: ['getAllFeedCommentAdmin', responseQuery],
        queryFn: () => getAllFeedCommentAdmin<T>(responseQuery),
        select: res => res.data.data.getAllFeedCommentAdmin
    })
    return query;
}

const feedCommentColumns: ColumnsType<IFeedCommentAdminResponse> = [
    {
        title: 'No',
        dataIndex: 'id',
        sorter: (a, b) => a.id - b.id
    },
    {
        title: '닉네임',
        dataIndex: 'nickName',
        sorter: (a, b) => a.nickName.localeCompare(b.nickName)
    },
    {
        title: '댓글 내용',
        dataIndex: 'content',
        render: (q: string, record) => <FeedCommentManageModal feedCommentId={record.id} btnText={q.length > 20 ? q?.slice(0, 20) + '...' : q} />
    },
    {
        title: '작성일시',
        dataIndex: 'createdDate',
        render: q => dayjs(q).format('YYYY.MM.DD HH:mm'),
        sorter: (a, b) => dayjs(b.createdDate).diff(dayjs(a.createdDate))
    },
    {
        title: '처리상태',
        dataIndex: 'isHidden',
        render: q => (q === undefined || q === null) ? '미처리' : q ? '숨김' : '노출'
    },
    {
        title: '신고횟수',
        dataIndex: 'totalClaimCnt',
        render: q => q ? q : 0,
        sorter: (a, b) => a.totalClaimCnt ? b.totalClaimCnt ? b.totalClaimCnt - a.totalClaimCnt : 1 : 1
    },
    {
        title: '원본 게시글 ID',
        dataIndex: 'feedId',
        render: q => <Link to={`/community/feed-manage/${q}`}>{q}</Link>
    },
    {
        title: '숨김 관리',
        dataIndex: 'id',
        render: q => <FeedCommentManageModal feedCommentId={q} />
    }

]

const filterFeedCommentIsHiddenOptions: DefaultOptionType[] = [
    {
        value: 'all',
        label: '전체',
    },
    {
        value: 'false',
        label: '노출',
    },
    {
        value: 'true',
        label: '숨김',
    },
    {
        value: 'null',
        label: '미처리',
    }
]

const filterFeedCommentSearchCategoryOptions: DefaultOptionType[] = [
    {
        value: 'nickName',
        label: '닉네임',
    },
    {
        value: 'content',
        label: '댓글 내용',
    },
    {
        value: 'feedId',
        label: '원본 게시글 ID',
    }
]

const feedCommentClaimDataList = [
    { id: 1, label: '스팸/홍보 도배글입니다.', value: '스팸/홍보 도배글입니다.' },
    { id: 2, label: '음란물입니다.', value: '음란물입니다.' },
    { id: 3, label: '불법 정보를 포함하고 있습니다.', value: '불법 정보를 포함하고 있습니다.' },
    { id: 4, label: '청소년에게 유해한 내용입니다.', value: '청소년에게 유해한 내용입니다.' },
    { id: 5, label: '욕설/생명경시/혐오/차별적 표현입니다.', value: '욕설/생명경시/혐오/차별적 표현입니다.' },
    { id: 6, label: '개인정보 노출 게시물입니다.', value: '개인정보 노출 게시물입니다.' },
    { id: 7, label: '불쾌한 표현이 있습니다.', value: '불쾌한 표현이 있습니다.' }
]

export { useGetFeedCommentAdminByFeedCommentId, useGetAllFeedCommentAdmin, feedCommentColumns, filterFeedCommentIsHiddenOptions, filterFeedCommentSearchCategoryOptions, feedCommentClaimDataList }